
import { useTranslation } from "react-i18next";
import NewPage from "../../../layouts/page/NewPage";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useState } from "react";
import MenuConfig from "../../../../constants/MenuConfig";
import Form from "./Form";
import Api from "../../../../constants/Api";
import { ApiError } from "../../../components/Common/ApiError";
import { successAlert } from "../../../components/alert/defaultAlert";
import axiosInstance from "../../../../services/AxiosInstance";
import { convertStringToStringDouble } from "../../../../utils/ConverterUtils";
import { toLocalISOString } from "../../../../utils/DateUtils";
import TransactionCashFlowType from "../../../components/Custom/CashFlow/Transaction/TransactionCashFlowType";
import PaymentMethod from "../../../components/Custom/Common/PaymentMethod/PaymentMethod";

const TransactionCashFlowNew = () => {

    const { t } = useTranslation();
    const [resetForm, setResetForm] = useState(false);

    // Define o schema de validação do form.
    const formSchema = Yup.object().shape({
        value: Yup.number()
            .typeError(t('validation.required.value'))
            .positive(t('validation.required.value'))
            .required(t('validation.required.value')),
        branch: Yup.object().required(t('validation.required.branch')).nullable(),
        description: Yup.string().required(t('validation.required.description')),
        type: Yup.object().required(t('validation.required.type')).nullable(),
        // Movimentação é regime de caixa: registra dinheiro que já entrou/saiu. Lançar no futuro
        // inflaria o saldo do caixa com dinheiro que ainda não existe.
        transactionDate: Yup.date()
            .typeError(t('validation.required.date'))
            .max(new Date(), t('cash_flow.validation.transaction_date_future'))
            .required(t('validation.required.date')),
    });

    // Define o formik.
    const formik = useFormik({
        initialValues: {
            value: 0.00,
            description: '',
            type: null,
            branch: null,
            transactionDate: new Date()
        },
        validationSchema: formSchema,
        onSubmit: (values) => {

            let payload = {
                value: convertStringToStringDouble(values.value),
                branch: {
                    id: values.branch.value
                },
                description: values.description,
                type: values.type.value === TransactionCashFlowType.OUT ? TransactionCashFlowType.OUT : TransactionCashFlowType.IN,
                paymentMethod: PaymentMethod.CASH,
                // ISO local (sem 'Z'): a data da movimentação é do fuso da barbearia, converter
                // para UTC deslocaria o lançamento de dia perto da meia-noite.
                transactionDate: toLocalISOString(values.transactionDate)
            }

            // Aciona a api
            axiosInstance.post(Api.cash_flow.transaction, payload)
                .then(() => {
                    successAlert(t('message.operation_successfully'), () => {
                        onReset();
                    });
                })
                .catch(error => ApiError(error))
                .finally(() => {
                    // Deixa habilitado o botão de submit.
                    formik.setSubmitting(false);
                });
        },
    });

    const onReset = () => {
        formik.resetForm();

        // resetForm volta para initialValues, cuja data foi capturada na montagem da tela.
        // Num caixa que lança várias movimentações seguidas isso deixaria o horário parado
        // no momento em que a tela abriu.
        formik.setFieldValue('transactionDate', new Date());

        // Alterna a versão para o formulário reaplicar a filial selecionada no contexto.
        setResetForm((currentValue) => !currentValue);
    }

    const onSubmit = (e) => {
        e.preventDefault();
        formik.handleSubmit();
    }

    return (
        <>
            <NewPage
                motherMenu={t('cash_flow.label')}
                childMenu={t('cash_flow.transactions')}
                activeMenu={t('new')}
                child={
                    <Form
                        formik={formik}
                        resetForm={resetForm} />}
                path={"/cash-flow/transactions"}
                isSubmitting={formik.isSubmitting}
                handleSubmit={onSubmit}
                cancelRoute={MenuConfig.cash_flow.transaction.route}
            />
        </>
    );
}

export default TransactionCashFlowNew;
